// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;To tell of your love early in the morning&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and of your faithfulness in the night-time,<br> </p> </div></div>";
// Exports
module.exports = code;